module.exports = __webpack_public_path__ + "img/10.f26fce5a.jpg";